/**
 * Body metric type enumeration — types of body measurements tracked
 */
export var BodyMetricType;
(function (BodyMetricType) {
    BodyMetricType["WEIGHT"] = "WEIGHT";
    BodyMetricType["HEIGHT"] = "HEIGHT";
    BodyMetricType["BODY_FAT"] = "BODY_FAT";
    BodyMetricType["MUSCLE_MASS"] = "MUSCLE_MASS";
    BodyMetricType["BONE_MASS"] = "BONE_MASS";
    BodyMetricType["WATER_PERCENTAGE"] = "WATER_PERCENTAGE";
    BodyMetricType["BMI"] = "BMI";
    BodyMetricType["WAIST_CIRCUMFERENCE"] = "WAIST_CIRCUMFERENCE";
    BodyMetricType["HIP_CIRCUMFERENCE"] = "HIP_CIRCUMFERENCE";
    BodyMetricType["CHEST_CIRCUMFERENCE"] = "CHEST_CIRCUMFERENCE";
    BodyMetricType["BICEP_CIRCUMFERENCE"] = "BICEP_CIRCUMFERENCE";
    BodyMetricType["THIGH_CIRCUMFERENCE"] = "THIGH_CIRCUMFERENCE";
    BodyMetricType["VISCERAL_FAT"] = "VISCERAL_FAT";
    BodyMetricType["BMR"] = "BMR";
    BodyMetricType["BODY_AGE"] = "BODY_AGE";
    BodyMetricType["HEART_RATE"] = "HEART_RATE";
    BodyMetricType["BLOOD_PRESSURE_SYS"] = "BLOOD_PRESSURE_SYS";
    BodyMetricType["BLOOD_PRESSURE_DIA"] = "BLOOD_PRESSURE_DIA";
    BodyMetricType["SYMPTOM"] = "SYMPTOM";
})(BodyMetricType || (BodyMetricType = {}));
/**
 * Body metric data source type — where the data comes from
 */
export var BodyMetricSourceType;
(function (BodyMetricSourceType) {
    BodyMetricSourceType["MANUAL"] = "MANUAL";
    BodyMetricSourceType["APPLE_HEALTH"] = "APPLE_HEALTH";
    BodyMetricSourceType["GOOGLE_FIT"] = "GOOGLE_FIT";
    BodyMetricSourceType["GARMIN"] = "GARMIN";
    BodyMetricSourceType["FITBIT"] = "FITBIT";
    BodyMetricSourceType["SAMSUNG_HEALTH"] = "SAMSUNG_HEALTH";
    BodyMetricSourceType["WITHINGS"] = "WITHINGS";
    BodyMetricSourceType["XIAOMI"] = "XIAOMI";
    BodyMetricSourceType["RENPHO"] = "RENPHO";
    BodyMetricSourceType["OPPO"] = "OPPO";
    BodyMetricSourceType["HUAWEI_HEALTH"] = "HUAWEI_HEALTH";
    BodyMetricSourceType["APPLE_WATCH"] = "APPLE_WATCH";
    BodyMetricSourceType["GARMIN_WATCH"] = "GARMIN_WATCH";
    BodyMetricSourceType["POLAR"] = "POLAR";
    BodyMetricSourceType["OTHER"] = "OTHER";
})(BodyMetricSourceType || (BodyMetricSourceType = {}));
/**
 * Unit type for body metric values
 */
export var BodyMetricUnit;
(function (BodyMetricUnit) {
    BodyMetricUnit["KG"] = "kg";
    BodyMetricUnit["CM"] = "cm";
    BodyMetricUnit["PERCENT"] = "%";
    BodyMetricUnit["BPM"] = "bpm";
    BodyMetricUnit["MMHG"] = "mmHg";
    BodyMetricUnit["KCAL"] = "kcal";
    BodyMetricUnit["YEARS"] = "years";
    BodyMetricUnit["RATING"] = "rating";
})(BodyMetricUnit || (BodyMetricUnit = {}));
